export const GET_DESKTOP_ACTIVITY_REQUESTED = 'GET_DESKTOP_ACTIVITY_REQUESTED'
export const GET_DESKTOP_ACTIVITY_SUCCESS = 'GET_DESKTOP_ACTIVITY_SUCCESS'
export const GET_DESKTOP_ACTIVITY_FAILURE = 'GET_DESKTOP_ACTIVITY_FAILURE'

export const GET_DESKTOP_EVENTS_REQUESTED = 'GET_DESKTOP_EVENTS_REQUESTED'
export const GET_DESKTOP_EVENTS_SUCCESS = 'GET_DESKTOP_EVENTS_SUCCESS'
export const GET_DESKTOP_EVENTS_FAILURE = 'GET_DESKTOP_EVENTS_FAILURE '
